import { PageHero } from "@/components/common/PageHero";
import { useSeo } from "@/lib/seo";

const BLOCKS = {
  mentions: {
    eyebrow: "Mentions légales",
    lines: ["Mentions légales"],
    sections: [
      { h: "Éditeur du site", p: "Losta Group — Holding d'acquisition et de développement d'entreprises. Coordonnées complètes (raison sociale, siège, registre du commerce) à compléter. [Placeholder — informations à renseigner]" },
      { h: "Directeur de la publication", p: "[Placeholder — nom du directeur de la publication à renseigner]" },
      { h: "Hébergement", p: "[Placeholder — hébergeur et coordonnées à renseigner]" },
      { h: "Propriété intellectuelle", p: "L'ensemble des éléments du site (textes, visuels, logo Losta Group) est protégé. Toute reproduction est interdite sans autorisation préalable." },
    ],
  },
  confidentialite: {
    eyebrow: "Confidentialité",
    lines: ["Politique de", "confidentialité"],
    sections: [
      { h: "Collecte des données", p: "Les informations recueillies via les formulaires (identité, entreprise, coordonnées, documents) sont utilisées uniquement pour l'étude d'une éventuelle opération avec Losta Group." },
      { h: "Confidentialité", p: "Vos données ne sont jamais revendues ni partagées à des fins publicitaires. Elles sont traitées de manière strictement confidentielle." },
      { h: "Cookies", p: "Le site n'utilise que les cookies nécessaires à son bon fonctionnement. Aucun cookie publicitaire n'est déposé." },
      { h: "Vos droits (RGPD)", p: "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données en écrivant à contact@losta.group." },
    ],
  },
};

export default function Legal({ type }) {
  const data = BLOCKS[type];
  useSeo({ title: `${data.eyebrow} | Losta Group`, description: `${data.eyebrow} du site Losta Group.`, path: `/${type}` });
  return (
    <>
      <PageHero eyebrow={data.eyebrow} lines={data.lines} />
      <section className="py-16 sm:py-24">
        <div className="mx-auto max-w-[800px] px-5 sm:px-8 space-y-10">
          {data.sections.map((s) => (
            <div key={s.h}>
              <h2 className="font-serif text-2xl text-white mb-3">{s.h}</h2>
              <p className="text-base text-[var(--txt-2)] font-light leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
